// CANONICAL COPY (GH #7115). src/constants/obligations/obl-transfer-basis-documentation.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-transfer-basis-documentation',
  title: 'Document valid transfer basis for each third-country transfer',
  description:
    "Confirm that each transfer of personal data to a third country or international organisation has a documented valid transfer basis (adequacy decision, standard contractual clauses, binding corporate rules, derogations) and is performed only on the controller's instruction (GDPR Art. 44–49; FSR ISAE 3000 Kontrolmål G.1–G.3). The processor shall maintain a per-transfer register covering destination country, transfer mechanism, transfer-impact assessment where required, and the controller's instruction authorising the transfer. Review the transfer register, sample transfer-basis evidence and the annual procedure-review record.",
  category: 'compliance',
  scfIds: ['SCF-PRV-006'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'transfer-basis-documented',
      description:
        'Every vendor with international transfers has a documented Art. 44–49 mechanism',
    },
    { type: 'document-published', description: 'Third-country transfer procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [
    { type: 'deep-link', target: 'vendors', label: 'Review Vendors' },
    { type: 'approve-document', label: 'Approve Document' },
  ],
};
